import { Loader } from '@googlemaps/js-api-loader';
import { env } from '../Environment.svelte';

export const loadGoogleMaps = async () => {
    const loader = new Loader({
        apiKey: env[env.stage].apiMaps.key,
        version: 'weekly',
        libraries: ['places', 'marker'],
    });
    await loader.importLibrary('maps');
    return new google.maps.Geocoder();
};

export const createPinElement = () => {
    return new google.maps.marker.PinElement({
        background: '#d31772',
        glyphColor: 'white',
    }).element;
};
